<template>
  <div class="search-form">
    <b-row>
      <b-col cols="12">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="
                $l('table_search_placeholder') ||
                  '客户名称/客户编号/部门名称/机构名称 搜索……'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_custNo') || '客户编号'">
              <el-input
                v-model.trim="form.custNo"
                :placeholder="$l('form_placeholder_custNo') || '请输入客户编号'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_customerName') || '客户名称'">
              <el-input
                v-model.trim="form.custName"
                :placeholder="
                  $l('form_placeholder_custName') || '请输入客户名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_depName') || '部门名称'">
              <el-input
                v-model.trim="form.depName"
                :placeholder="
                  $l('form_placeholder_depName') || '请输入部门名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orgName') || '机构名称'">
              <el-input
                v-model.trim="form.orgName"
                :placeholder="
                  $l('form_placeholder_orgName') || '请输入机构名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_modifyBy') || '请选择修改人'"
                clearable
                filterable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    :placeholder="
                      $l('form_placeholder_modifyDateStart') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    :placeholder="
                      $l('form_placeholder_modifyDateEnd') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
